import { request } from './request';
import request_body from './request_body';
import * as echarts from "echarts";


export default {
	request_body,
	async login(data) {
		request_body.logout();
		let rs = await request("/login/auth", data);
		if (rs.code == 200) {
			request_body.login(rs.token);
		}
		return rs;
	},
	async getMenus() {
		return request("/main/menu");
	},
	async createProject(title,start_date) {
		return request("/project/create_project", {title,start_date})
	},
	async getProjects() {
		return request("/project/get_projects")
	},
	async delPriject(id) {
		return request("/project/del_projects",{id})
	},
	async project(id) {
		return request("/project/project", {id})
	},
	async createOrganize(name) {
		return request("/project/create_organize", {name})
	},
	async getOrganizes(org_id) {
		return request("/project/get_organizes", {org_id})
	},
	async updateOrgAdmin(id, admin_name, admin_phone) {
		return request("/project/update_org_admin", {id, admin_name, admin_phone})
	},
	async getOrgAdmin(id) {
		return request("/project/get_org_admin", {id})
	},
	async updateProjectSetting(project_id, name, org_ids) {
		return request("/project/update_project_setting", {project_id, name, org_ids});
	},
	async getProjectBuilders(project_id) {
		return request("/project/get_project_builders", {project_id});
	},
	async saveProjectBuildingCount(project_id, count) {
		return request("/project/save_project_building_count", {project_id, count})
	},
	async saveProjectFloorCount(project_id, count) {
		return request("/project/save_project_floor_count", {project_id, count})
	},
	async saveProjectStartDate(project_id, start_date) {
		return request("/project/save_project_start_date", {project_id, start_date})
	},
	async getFloorTypes() {
		return request("/project/get_floor_types")
	},
	async getFloorTypesById(project_id) {
		return request("/project/get_floor_types_by_proId",{project_id})
	},
	async saveProjectCount(building_count,project_id) {
		return request("/project/save_project_count",{building_count,project_id})
	},
	async downProjectCount(project_id) {
		return request("/project/down_project_count",{project_id})
	},
	async getProTime(type,project_id) {
		return request("/project/get_pro_time",{type,project_id})
	},
	async saveBuildingName(id,project_id, index, name) {
		return request("/project/save_building_name", {id,project_id, index, name})
	},
	async delBuildingName(id,project_id) {
		return request("/project/del_building_name", {id,project_id})
	},
	async getFloorCountByProjectId(project_id) {
		return request("/project/get_floor_count_by_projectId", {project_id})
	},
	async saveTime(building_id,project_id,project_name,type,start_time,end_time,period,floorIdx) {
		return request("/project/save_time", {building_id,project_id,project_name,type,start_time,end_time,period,floorIdx})
	},
	async getIdByName(project_name) {
		return request("/project/get_id_by_name", {project_name})
	},
	async getBuildings(project_id) {
		return request("/project/get_buildings", {project_id})
	},
	async saveFloorPeriod(project_id, building_id, index, key, type, period) {
		return request("/project/save_floor_period", {project_id, building_id, index, key, type, period})
	},
	async getFloorData(project_id) {
		return request("/project/get_floor_data", {project_id})
	},
	async getDocByProjectId(project_id) {
		return request("/project/get_doc_by_projectId", {project_id})
	},
	async uploadFile(file) {
		return request("/project/uploadFile", {file})
	},
	async deleteDoc(id,link) {
		return request("/project/delete_doc", {id,link})
	},
	async gecDocByCondition(name,beginTime,endTime,project_id) {
		return request("/project/get_doc_by_condition", {name,beginTime,endTime,project_id})
	},
	async getCompletePercent() {
		return request("/project/get_complete_by_company")
	},
	async getNumber() {
		return request("/project/get_number")
	},
	async getDays() {
		return request("/project/get_days")
	},
	async getWorks(ifDo) {
		return request("/project/get_near_works",{ifDo})
	},
	async getOverTimeWorks() {
		return request("/project/get_over_time_works")
	},
	async savePro(proName) {
		return request("/project/save_pro",{proName})
	},
	async delPro(id) {
		return request("/project/del_pro",{id})
	},
	async saveOrder(proId,id) {
		return request("/project/save_order",{proId,id})
	},
	async getOrders(id) {
		return request("/project/get_order",{id})
	},
	async getUserGroup() {
		return request("/user/get_user_group");
	},
	async addUserGroup(name) {
		return request("/user/add_user_group", {name})
	},
	async getRegToken() {
		return request("/user/get_token");
	},
	async getCompanyByToken(token) {
		return request("/open/get_company_by_token", {token});
	},
	async getGroupsByToken(token) {
		return request("/open/get_groups_by_token", {token});
	},
	async createUserByToken(data) {
		return request("/open/create_user_by_token", data);
	},
	async getGroupMember() {
		return request("/user/get_group_member");
	},
	async createContractTemplate(body) {
		return request("/project/create_contract_template", body, "application/json")
	},
	async getContractTemplates() {
		return request("/project/get_contract_templates")
	},
	async saveContract(name, template_id, project_id) {
		return request("/project/save_contract", {name, template_id, project_id})
	},
	async getContracts(project_id) {
		return request("/project/get_contracts", {project_id})
	},
	async getContactDetails(id) {
		return request("/project/get_contact_details", {id})
	},
	async getMyContactDetails(id) {
		return request("/project/get_my_contact_details", {id})
	},
	async getContractMarks(id) {
		return request("/project/get_contract_marks", {id})
	},
	async markContract(id, remark) {
		return request("/project/mark_contract", {id, remark})
	},
	async getInvProjects(project_id) {
		return request("/project/get_inv_projects", {project_id})
	},
	async getCompanyRole() {
		return request("/project/get_company_role")
	},
	async getCompanyStaff() {
		return request("/project/get_company_staff")
	},
	async saveProjectFlow(type, notify_type, staff) {
		return request("/project/save_project_flow", {type, notify_type, staff})
	},
	async getProjectFlow() {
		return request("/project/get_project_flow")
	},
	async getProjectFlowInfo() {
		return request("/project/get_project_flow_info", {})
	},
	async getBuildingInfo(id) {
		return request("/project/get_building_info", {id})
	},
	async updateBuildingFloorCount(id, floor) {
		return request("/project/update_building_floor_count", {id, floor})
	},
	async updateBuildingStartTime(building_id, start_date, period, id) {
		return request("/project/update_building_start_time", {building_id, start_date, period, id})
	},
	async saveProjectBuildingFlow(building_id, start_date, period, name) {
		return request("/project/save_project_building_flow", {building_id, start_date, period, name})
	},
	async updateFlowStartTime(building_id, start_date, period, id) {
		return request("/project/update_flow_start_time", {building_id, start_date, period, id})
	},
	async copyBuilding(building_id, name) {
		return request("/project/copy_building", {building_id, name})
	},
	async getCompanyAgents() {
		return request("/project/get_company_agents")
	},
	async saveProjectAgent(id, agent_id) {
		return request("/project/save_project_agent", {id, agent_id})
	},
}